'use strict';

var EditAlertConfiguration = require('actionGroups/alertConfiguration/AlertConfiguration');

module.exports = {
  Model: EditAlertConfiguration,
};
